<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      class="icon__stroke"
      cx="7.98"
      cy="4.2308"
      rx="3.23"
      ry="3.2308"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="icon__stroke"
      d="M8 9C5.02015 9 1 11 1 12.6667C1 14.3333 2.75 15 4.9375 15H8"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="icon__stroke"
      d="M8 9C10.9798 9 15 11 15 12.6667C15 14.3333 13.25 15 11.0625 15H8"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "IconProfile",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
